module.exports = __webpack_public_path__ + "static/media/Schrocken-Logo-Dark.f3760bf8.png";